// extracted by mini-css-extract-plugin
export default {"loader":"general_loader__Zb6FN"};